module.exports = __webpack_public_path__ + "static/portfolio_gallery_25-542a8579afca43b18c906e2ad9f8ecd2.jpg";